import { PricePeriodUnit } from "@/models/PricePeriodUnit"
import type { JSONSchemaType } from "ajv"

export type PricePeriod = {
  unit: PricePeriodUnit
  duration: number
  recurring: boolean
}

// Helper to format duration string similar to Swift's unitDurationString
export const getUnitDurationString = (period: PricePeriod): string => {
  if (period.duration === 1) {
    return period.unit
  }

  // Replicating Swift's DateComponentsFormatter logic
  switch (period.unit) {
    case "year":
      return period.duration === 1 ? "year" : `${period.duration} years`
    case "month":
      return period.duration === 1 ? "month" : `${period.duration} months`
    case "week":
      return period.duration === 1 ? "week" : `${period.duration} weeks`
    case "day":
      return period.duration === 1 ? "day" : `${period.duration} days`
    default:
      return period.unit
  }
}

export const schema: JSONSchemaType<PricePeriod> = {
  $id: "https://newie.app/schemas/pricePeriod.json",
  type: "object",
  properties: {
    unit: {
      type: "string",
      enum: [
        "year",
        "month",
        "fortnight",
        "fourWeeks",
        "sixWeeks",
        "twelveWeeks",
        "week",
        "day",
      ],
    },
    duration: { type: "number" },
    recurring: { type: "boolean" },
  },
  required: ["unit", "duration", "recurring"],
}
